import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const ConfirmDialog = ({
  open,
  onOpenChange,
  title = "Are you sure you want to delete?",
  description,
  confirmLabel = "Delete",
  onConfirm,
  testid,
  confirmTestid,
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent
      data-testid={testid}
      className="gap-3 rounded-[20px] border-0 p-6 shadow-2xl sm:max-w-[400px]"
    >
      <AlertDialogHeader>
        <AlertDialogTitle className="text-[19px] font-semibold tracking-tight">
          {title}
        </AlertDialogTitle>
        {description && (
          <AlertDialogDescription className="text-[14.5px] leading-relaxed text-[#6E6E73]">
            {description}
          </AlertDialogDescription>
        )}
      </AlertDialogHeader>
      <AlertDialogFooter className="mt-2 gap-2">
        <AlertDialogCancel className="h-10 rounded-full border-[#E1E1E6] px-5 text-[14px] font-medium">
          Cancel
        </AlertDialogCancel>
        <AlertDialogAction
          data-testid={confirmTestid}
          onClick={onConfirm}
          className="h-10 rounded-full bg-[#C8102E] px-5 text-[14px] font-medium text-white hover:bg-[#A60D26]"
        >
          {confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default ConfirmDialog;
